import { Injector, NgModule, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
 
import { NextPage } from '@cvx/nextpage';
 
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './components/home/home.component';
import { LibEditorComponent } from './components/libEditor/libEditor.component';
import { LibraryReducer } from './ngrx/libraries/library.reducer';
 
import { StoreModule } from '@ngrx/store';
import { AppState } from './app.state';
import { LibraryTableComponent } from './components/library-table/library-table.component';
import { LibrarySelectorComponent } from './components/library-selector/library-selector.component';
import { UserAccessComponent } from './components/userAccess/userAccess.component';
import { AccessDashboardComponent } from './components/access-dashboard/access-dashboard.component';
import { MsalModule, MsalService, MSAL_INSTANCE, MsalInterceptor, MsalGuard } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';

import { environment } from '../environments/environment';
import { RoleGuard } from './guards/role.guard';
 
const protectedResourceMap = new Map<string, Array<string>>();
 
export function MSALInstanceFactory(): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: "https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/",
      redirectUri: `${environment.baseUrl}/sign-in`,
      postLogoutRedirectUri: `${environment.baseUrl}/`,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback: () => {},
        piiLoggingEnabled: false,
      },
    },
  });
}
 
export function initializeMsal(msalService: MsalService): () => Promise<void> {
  return () => msalService.instance.initialize();
}
 
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LibEditorComponent,
    LibraryTableComponent,
    LibrarySelectorComponent,
    UserAccessComponent,
    AccessDashboardComponent
  ],
  exports: [],
  bootstrap: [AppComponent],
  imports: [
    NextPage,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    CommonModule,
    MsalModule.forRoot(
      MSALInstanceFactory(),
      {
        interactionType: InteractionType.Popup, // MSAL Guard Configuration
        authRequest: {
          scopes: environment.scopes,
        },
        loginFailedRoute: "/login-failed",
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap,
      }
    ),
    StoreModule.forRoot<AppState>({ library: LibraryReducer })
  ],
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    MsalService,
    MsalGuard,
    RoleGuard,
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [MsalService],
      multi: true
    }
  ]
})
export class AppModule {
  constructor(private injector: Injector) { }
  ngBootStrap() { }
}